import React from 'react';
import { cn } from '@/lib/utils';
import type { Message } from '@/types/chat';
import MessageImageGallery from './MessageImageGallery';

interface StandardMessageProps {
  message: Message;
  isFromUser: boolean;
}

const StandardMessage: React.FC<StandardMessageProps> = ({
  message,
  isFromUser
}) => {
  const formattedTime = new Date(message.sent_at).toLocaleTimeString([], { 
    hour: '2-digit', 
    minute: '2-digit' 
  });

  return (
    <div 
      className={cn(
        "flex flex-col max-w-[80%]",
        isFromUser ? "ml-auto items-end" : "mr-auto items-start"
      )}
    >
      {/* Message bubble - independent width based on content */}
      <div 
        className={cn(
          "rounded-lg p-3 break-words shadow-sm max-w-fit",
          isFromUser 
            ? "bg-muted border border-border text-foreground rounded-br-none" 
            : "bg-primary text-primary-foreground rounded-bl-none"
        )}
      >
        {/* Message text */}
        {message.content && (
          <div className="text-sm mb-2">{message.content}</div>
        )}
        
        {/* Timestamp */}
        <div className={cn(
          "text-xs text-right mt-2",
          isFromUser ? "text-secondary-foreground/70" : "text-primary-foreground/70"
        )}>
          {formattedTime}
        </div>
      </div>
      
      {/* Message images - independent width, aligned with bubble */}
      {message.images && message.images.length > 0 && (
        <MessageImageGallery 
          images={message.images}
          className="mt-2"
        />
      )}
    </div>
  );
};

export default StandardMessage;